// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3_EQe","upload":"Small_upload__1zXa_","imageWrap":"Small_imageWrap__1_59r","removeBtn":"Small_removeBtn__2oleP"};